export default "__VITE_ASSET__CzeYgipw__"